<template>
  <div class="xitongxiaoxi">
    <div class="xt-title">
		<span class="xt-title-span">{{$t('all.wentibangzhu')}}</span>
		<span class="xt-title-span1" @click="handleUploadFk">{{$t('all.woyaofankui')}}</span>
	</div>
    <div class="xt-list">
      <div class="wt-list-item" v-for="(item, index) in list" :key="item.id || index">
        <img src="../../assets/image/wenda_1@2x.png" alt="" v-if="index == 0"/>
		<img src="../../assets/image/wenda_2@2x.png" alt="" v-if="index == 1"/>
		<img src="../../assets/image/wenda_3@2x.png" alt="" v-if="index == 2"/>
		<img src="../../assets/image/wenda_4@2x.png" alt="" v-if="index == 3"/>
		<img src="../../assets/image/wenda_5@2x.png" alt="" v-if="index == 4"/>
		<div class="wt-list-item-box">
			<div class="wt-list-item-box-title">{{item.title}}</div>
			<div class="wt-list-item-box-content">{{item.content}}</div>
		</div>
      </div>
      <!-- 当没有更多数据且列表为空时，显示空状态 -->
      <kong v-if="isKong"></kong>
    </div>
  </div>
</template>

<script>
import kong from "../kong/kong.vue";
import { getFaqList } from "@/api/user";

export default {
  name: 'xitongxiaoxi',
  components: {
    kong
  },
  data() {
    return {
      queryParams: {
        page: 1,
        size: 10,
      },
      list: [],
	  isKong:false
    };
  },
  mounted() {
    this.getFaqList();
  },
  methods: {
    // 获取问题列表
    async getFaqList() {
      const response = await getFaqList(this.queryParams);
	  this.list = response.data
	  if(this.list.length > 0){
		  this.isKong = false
	  }else{
		  this.isKong = true
	  }
    },
	//我要反馈
	handleUploadFk(){
		this.$emit('uploadFk')
	}
  }
};
</script>

<style scoped lang="scss">
	@import "./wentibangzhu.css";
</style>


// WEBPACK FOOTER //
// wentibangzhu.vue?9f388772